// extracted by mini-css-extract-plugin
export default {"container":"Stats_container__n3SUP","stat":"Stats_stat__eeAGf"};